import { Image } from 'antd-mobile'
import { AddSquareOutline } from 'antd-mobile-icons'
import { isEmpty } from 'lodash-es'
import { toJS } from 'mobx'
import { useLocalStore, observer, useLocalObservable } from 'mobx-react-lite'
import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import usePopup from '@/components/NewEditForm/UILibrary/HYBVant/HPopup/hooks/usePopup'
import jobStore from '@/store/components/entryJob'
import dictStore from '@/store/global/dictStore'
import { getUrlParams } from '@/utils'
import getQuery from '@/utils/getQuery'

import { HBlockAdd } from '../../HYBVant'

import LongPopup from './LongPopup'
import Popup from './Popup'
import PopupNoAuth from './PopupNoAuth'
import useLocalRewardPunishment from './useLocalRewardPunishment'
import useRewardPunishment from './useRewardPunishment'
import './index.less'

const LocalEducation: React.FC<any> = observer(({ onConfirm, value, isAuth = true }) => {
  const {
    education = [],
    changeEducationStatus,
    changeAllEducation
  } = useLocalStore(() => jobStore)
  const location = useLocation()
  const store = useLocalStore(() => dictStore)
  const { open, modalData, onCancel, onOpen } = usePopup({})
  const { id } = getUrlParams()
  const isNoAuth = location.pathname.match('/entry/fast')
  const qrcodeId = isNoAuth ? id : ''

  const add = () => {
    changeEducationStatus('Add')
    onOpen({ status: 'Add' })
  }

  const edit = (index: number) => {
    education.map((x, i) => {
      if (index === i) {
        x.active = 1
      } else {
        x.active = 0
      }
      return x
    })
    changeEducationStatus('Edit')
    onOpen({ status: 'Edit' })
  }

  useEffect(() => {
    if (onConfirm) onConfirm(education)
  }, [education])

  useEffect(() => {
    if (value && Array.isArray(value)) {
      !value.some((x) => education.includes(x)) && changeAllEducation(value)
    } else changeAllEducation([])
  }, [value])

  console.log(toJS(education), 'education', qrcodeId)

  return (
    <div className='education'>
      {!isEmpty(education) && (
        <div className='education-content-wrapper'>
          {education.map((x, index) => (
            <div key={x} className='education-content' onClick={() => isAuth && edit(index)}>
              <div className='education-content-col-1'>
                <div className='education-content-1'>
                  {x.graduate_school}（
                  {
                    store
                      .getOptions('HRM_EDUCATION_LEVEL')
                      ?.find((y: any) => y.value === x.education_level)?.name
                  }
                  ）
                </div>
                <div className='education-content-3'>
                  {x.start_date || '-'}&nbsp;&nbsp;至&nbsp;&nbsp;{x.end_date || '-'}
                </div>
              </div>
              <div className='education-content-col-2'>
                {isAuth && (
                  <Image
                    className='education-content-col-2-img'
                    src='https://s.huiyunban.cn/1747191709529280512.png'
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      )}
      {isAuth && <HBlockAdd onClick={add} text='添加教育经历' />}
      {open && qrcodeId ? (
        <PopupNoAuth visible={open} onCancel={onCancel} qrcodeId={qrcodeId} modalData={modalData} />
      ) : open && !qrcodeId ? (
        <Popup visible={open} onCancel={onCancel} modalData={modalData} />
      ) : null}
    </div>
  )
})
const LongTerm: React.FC<any> = observer(({ isLocalObserver, onConfirm, value, isAuth }) => {
  const staffId = decodeURIComponent(getQuery('staffId') || '')
  const { employeeIds } = useLocalObservable(() => jobStore)
  const staff_id = employeeIds?.[0] || staffId
  const local = useLocalRewardPunishment({
    onConfirm,
    value
  })
  const remote = useRewardPunishment({
    onConfirm,
    value
  })
  const {
    add,
    edit,
    open,
    modalData,
    onCancel,
    runSaveEducation,
    runDeleteHrmEducation,
    deleteHrmEducationLoading,
    saveEducationLoading
  } = isLocalObserver ? local : remote
  return (
    <div className='health_certificate'>
      {!isEmpty(value) && (
        <div className='health_certificate-content-wrapper'>
          {value?.map((x: any, index: number) => (
            <div
              key={x}
              className='health_certificate-content'
              onClick={() => isAuth && edit(index)}
            >
              <div className='health_certificate-content-col-1'>
                <div className='health_certificate-content-1'>
                  {x?.graduate_school || '-'}
                  {x?.education_level_name ? ` (${x?.education_level_name}) ` : ''}
                </div>
                <div className='health_certificate-content-3'>
                  {x?.start_date || '-'}&nbsp;&nbsp;至&nbsp;&nbsp;{x?.end_date || '-'}
                </div>
              </div>
              <div className='health_certificate-content-col-2'>
                {isAuth && (
                  <Image
                    className='hyb-com-concat-content-col-2-img'
                    src='https://s.huiyunban.cn/1747191709529280512.png'
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      )}
      {isAuth && <HBlockAdd onClick={add} text='添加教育经历' />}
      {open && (
        <LongPopup
          visible={open}
          onCancel={onCancel}
          modalData={{
            ...modalData,
            staff_id,
            runSaveEducation,
            runDeleteHrmEducation,
            deleteHrmEducationLoading,
            saveEducationLoading
          }}
        />
      )}
    </div>
  )
})
// 教育经历
const EducationBox: React.FC<any> = ({
  onConfirm,
  value,
  isLocalObserver = true,
  isAuth = true
}) => {
  const location = useLocation()
  return isLocalObserver && location.pathname !== '/entry/stay/addEmployees' ? (
    <LocalEducation onConfirm={onConfirm} value={value} isAuth={isAuth} />
  ) : (
    <LongTerm
      isLocalObserver={isLocalObserver}
      onConfirm={onConfirm}
      value={value}
      isAuth={isAuth}
    />
  )
}
export default EducationBox
